(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('@freska-fi/ui-box'), require('@freska-fi/ui-typography'), require('@mui/material/styles')) :
    typeof define === 'function' && define.amd ? define(['react', '@freska-fi/ui-box', '@freska-fi/ui-typography', '@mui/material/styles'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['@freska-fi/ui-locale-picker'] = factory(global.React, global.Box, global.Typography, global.styles));
}(this, (function (React, Box, Typography, styles) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);
    var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);

    function LocalePicker(_a) {
        var locales = _a.locales, value = _a.value, onChange = _a.onChange;
        var theme = styles.useTheme();
        return (React__default['default'].createElement(Box__default['default'], { display: "block", onClick: function (event) {
                event.preventDefault();
                onChange === null || onChange === void 0 ? void 0 : onChange(value === locales[0] ? locales[1] : locales[0]);
            } }, locales.map(function (locale) { return (React__default['default'].createElement(Box__default['default'], { component: "label", key: locale, sx: {
                display: 'inline-block',
                padding: '5px 6px',
                margin: 0,
                width: 32,
                color: value === locale ? theme.palette.common.white : theme.palette.action.disabled,
                backgroundColor: value === locale ? theme.palette.primary.main : theme.palette.background.default,
                cursor: 'pointer',
            } },
            React__default['default'].createElement(Box__default['default'], { component: "input", type: "radio", name: "locale", value: locale, checked: value === locale, onChange: function (event) { return onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value); }, sx: { display: 'none', width: 0 } }),
            React__default['default'].createElement(Typography__default['default'], { component: "p", variant: "body2", align: "center", sx: { fontSize: 12, fontWeight: 700 } }, (locale === 'nb' ? 'no' : locale).toUpperCase()))); })));
    }

    return LocalePicker;

})));
